import { useCallback } from 'react';

import { useCrowdfundingProvider } from '#Context/index.js';
import { useSelectStoreItemProvider } from '#components/organisms/modals/SelectStoreItemModalFlow.js';
import { PeerTypes, useShowConsumerCampaignSettingsById } from '@givebacks/api/store';

const usePeerCreditModal = () => {
  const { causeId, campaignId } = useCrowdfundingProvider();
  const { data: campaignSettings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });
  const { openModalById, setMeta } = useSelectStoreItemProvider({});

  const handleSelectPeer = useCallback(
    (cartCredit: string, peerType: PeerTypes) => {
      setMeta((prev) => ({
        ...prev,
        cartCredit: { credit_to: [cartCredit], credit_write_in: [], peerType: peerType },
      }));
      openModalById('StoreItemOptions');
    },
    [openModalById, setMeta]
  );

  const handlePeerCreditOpen = useCallback(() => {
    if (campaignSettings?.isPeersEnabled || campaignSettings?.isTeamsEnabled) {
      openModalById('StoreItemCrediting');
    } else {
      openModalById('StoreItemOptions');
    }
  }, [campaignSettings?.isPeersEnabled, campaignSettings?.isTeamsEnabled, openModalById]);
  return {
    handlePeerCreditOpen,
    handleSelectPeer,
  };
};

export { usePeerCreditModal };
